import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import "./NewScheduleModal.css";

const NewScheduleModal = ({ isOpen, onClose, initialStartTime, initialEndTime, addNewEvent }) => {
  const [selectionType, setSelectionType] = useState("content"); // Default to content
  const [contentList, setContentList] = useState([]);
  const [playlistList, setPlaylistList] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [startDate, setStartDate] = useState(initialStartTime?.slice(0, 10) || "");
  const [startTime, setStartTime] = useState(initialStartTime?.slice(11, 16) || "");
  const [endDate, setEndDate] = useState(initialEndTime?.slice(0, 10) || "");
  const [endTime, setEndTime] = useState(initialEndTime?.slice(11, 16) || "");
  const [repeatOption, setRepeatOption] = useState("once");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch content and playlists from Firestore
        const contentRef = collection(db, "media");
        const contentSnap = await getDocs(contentRef);
        setContentList(contentSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));

        const playlistRef = collection(db, "playlists");
        const playlistSnap = await getDocs(playlistRef);
        setPlaylistList(playlistSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, []);

  const handleSave = () => {
    if (!selectedItem || !startDate || !startTime || !endDate || !endTime) {
      alert("Please fill all required fields.");
      return;
    }

    const newEvent = {
      title: selectedItem,
      start: new Date(`${startDate}T${startTime}`),
      end: new Date(`${endDate}T${endTime}`),
      repeat: repeatOption,
    };

    addNewEvent(newEvent);
    onClose();
  };

  return (
    isOpen && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Add to Schedule</h2>

          {/* Content Type Selection */}
          <label>Type:</label>
          <select value={selectionType} onChange={(e) => setSelectionType(e.target.value)}>
            <option value="content">Content</option>
            <option value="playlist">Playlist</option>
          </select>

          {/* Content/Playlist Dropdown */}
          <label>Select {selectionType === "content" ? "Content" : "Playlist"}:</label>
          <select value={selectedItem} onChange={(e) => setSelectedItem(e.target.value)}>
            <option value="">Select {selectionType === "content" ? "Content" : "Playlist"}</option>
            {(selectionType === "content" ? contentList : playlistList).map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>

          {/* Start Date & Time */}
          <label>Start Date:</label>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />

          <label>Start Time:</label>
          <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />

          {/* End Date & Time */}
          <label>End Date:</label>
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

          <label>End Time:</label>
          <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />

          {/* Repeat Options */}
          <label>Repeat:</label>
          <select value={repeatOption} onChange={(e) => setRepeatOption(e.target.value)}>
            <option value="once">Once</option>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>

          {/* Action Buttons */}
          <div className="modal-actions">
            <button className="btn save" onClick={handleSave}>Save</button>
            <button className="btn cancel" onClick={onClose}>Cancel</button>
          </div>
        </div>
      </div>
    )
  );
};

export default NewScheduleModal;
